"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var FormErr =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(FormErr, _Error);

  function FormErr(_ref) {
    var _this;

    var form = _ref.form;
    (0, _classCallCheck2.default)(this, FormErr);
    // We stringify the error so that it can be unpacked by any API
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormErr).call(this, JSON.stringify({
      message: 'invalid input',
      error: form.getErrs()
    })));
    _this.name = 'FormErr';
    return _this;
  }

  return FormErr;
}((0, _wrapNativeSuper2.default)(Error));

exports.default = FormErr;